import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { FileRejection } from 'react-dropzone';
import readXlsxFile from 'read-excel-file';
import { IConsultantImportStats, IConsultant, pingOnUpload } from 'wisestep-api';
import {
  FileTypeVariants,
  Label,
  WsColors,
  WsFileUpload,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import MapSpreadsheetColumns from './MapSpreadsheetColumns';

const UploadBulk = () => {
  const [selectedConsultantFile, setSelectedConsultantFile] = useState<File>();
  const [newConsultantPayload, setNewConsultantPayload] = useState<{
    consultants: [] | IConsultant[];
    consultantImportStats: Partial<IConsultantImportStats>;
  }>({
    consultants: [],
    consultantImportStats: {},
  });

  useEffect(() => {
    if (selectedConsultantFile) {
      readXlsxFile(selectedConsultantFile).then((rows) => {
        const consultArray = rows.map((row) => ({
          ...(row[0] && { column1: row[0] }),
          ...(row[1] && { column2: row[1] }),
          ...(row[2] && { column3: row[2] }),
          ...(row[3] && { column4: row[3] }),
          ...(row[4] && { column5: row[4] }),
          ...(row[5] && { column6: row[5] }),
          ...(row[6] && { column7: row[6] }),
          ...(row[7] && { column8: row[7] }),
          ...(row[8] && { column9: row[8] }),
          ...(row[9] && { column10: row[9] }),
          ...(row[10] && { column11: row[10] }),
          id: null,
          organization: null,
          ownerId: null,
          ownerName: null,
          ownerPhone: null,
          phoneNumber: null,
          sharedToRecruiters: [],
          sharedToTeams: [],
          uniqueId: '',
          workAuthorization: '',
          workAuthorizationCategory: '',
          workspaceId: '',
        }));

        setNewConsultantPayload((prev) => {
          prev.consultants = consultArray as [];
          return { ...prev };
        });
      });
    }
  }, [selectedConsultantFile]);

  const onFileUpload = async (files: File[]) => {
    setSelectedConsultantFile(files[0]);
    try {
      const response = await pingOnUpload();
      newConsultantPayload.consultantImportStats = response.data;
      setNewConsultantPayload({ ...newConsultantPayload });
    } catch (e) {
      console.log(e);
    }
  };

  const onFileRejected = (files: FileRejection[]) => {
    files.map((file) => {
      file.errors.map((error) => {
        console.log('rejected' + error.message);
      });
    });
  };

  return (
    <Grid>
      {newConsultantPayload.consultants.length > 0 ? (
        <MapSpreadsheetColumns
          parsedData={newConsultantPayload}
          setNewConsultantPayload={setNewConsultantPayload}
        />
      ) : (
        <>
          <WsFileUpload
            name="consultantSpreadsheet"
            onUpload={onFileUpload}
            placeholderText="Drag & drop .xls,.xlvs or .csv file < 1MB"
            fileTypes={FileTypeVariants.BULKUPLOAD}
            onFileRejected={onFileRejected}
          />
          <Label sx={{ fontWeight: 'bold', my: 2, color: WsColors.TertiaryShades800 }}>Note:</Label>

          {/* <Stack direction="row" justifyContent="flex-start" spacing={2} mb={2} alignItems="center">
            <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SENARY}>
              Sample Consultant Information format
            </WsTypography>

            <WsButton variant="text" startIcon={<WsIconDownload color={WsColors.TheBlues500} />}>
              Download File
            </WsButton>
          </Stack> */}
          <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.SENARY}>
            Mandatory Columns are Name, Skills, Current Location, Job Title & Visa
          </WsTypography>
        </>
      )}
    </Grid>
  );
};

export default UploadBulk;
